import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BulkActionToolbar, FullTable } from 'components';
import {
  ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS, paidPayableBatchesDetailsBody, paidPayableBatchesDetailsHead,
} from './constants';
import { LoadDetailSwitcher } from '../../loads';
import { AddPayoutDate } from './addPayoutDate';
import { MoveTo } from './moveTo';
import { usePrimaryModal } from 'utils';
import { loadActions } from 'store';

export const PaidPayableBatchesDetails = ({ batch }) => {
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [showBulkAction, setShowBulkAction] = useState(false);
  const dispatch = useDispatch();
  const { loadsList, loadsPayableBatches } = useSelector((state) => ({
    loadsList: state.loads.loadsList,
    loadsPayableBatches: state.loads.loadsPayableBatches,
  }));
  const { openPrimary, closePrimary, params } = usePrimaryModal();


  useEffect(() => {
    const isEmpty = Object.keys(params).length === 0;

    setShowBulkAction(isEmpty);
  }, [params]);

  useEffect(() => {
    if (batch?.id) {
      dispatch(loadActions.getLoadsPayableBatches(batch?.id));
    }
  }, [batch?.id]);


  const handleSelectAll = (e, selectAll) => {
    if (e.target.checked || selectAll) {
      const allIds = loadsList?.loads?.map(load => load);
      setSelectedLoads(allIds);
    } else {
      setSelectedLoads([]);
    }
  };


  return (
    <div style={{ padding: '10px', background: '#E6ECF3' }}>
      <FullTable
        head={paidPayableBatchesDetailsHead()}
        body={paidPayableBatchesDetailsBody()}
        loadingType={ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS}
        list={loadsPayableBatches}
        fixHeight='45vh'
        margin={'0px'}
        handleClick={(id) =>
          openPrimary(<LoadDetailSwitcher loadId={id} />)
        }
        noText={'Paid Payable Batches'}
      />

      {(!!selectedLoads?.length && showBulkAction) &&
        <BulkActionToolbar
          selectedCount={selectedLoads?.length}
          handleSelectOrUnselectAll={handleSelectAll}
          handleCreateBatch={() => openPrimary(<AddPayoutDate handleClose={closePrimary} />)}
          handleMoveTo={() => openPrimary(<MoveTo handleClose={closePrimary} />)}
          isAllSelected={selectedLoads?.length === loadsList?.loads?.length}
          handleClose={() => setSelectedLoads([])}
        />
      }
    </div>
  );
};

